import { buildAxonItem, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonBeginCheckout() {
  function reportBeginCheckout(
    configId: string | number | undefined,
    productId: string | number,
    itemName: 'Coins Package' | 'Membership',
    price: string | number,
  ) {
    pushAxonEvent('begin_checkout', {
      currency: 'USD',
      value: Number(price),
      items: [buildAxonItem(configId, productId, itemName, price)],
    })
  }

  return { reportBeginCheckout }
}
